import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

import AddIcon from "@mui/icons-material/Add";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Fab from "@mui/material/Fab";
import EditIcon from "@mui/icons-material/Edit";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import swal from 'sweetalert';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Pagination from "react-js-pagination";
import AddProjectForm from "./AddProject/AddProjectForm";
import SearchProject from "./SearchProject/SearchProject";
import CheckIcon from '@mui/icons-material/Check';
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import Button from '@mui/material/Button';
import Details_projects from "./Details/Details_projects";
import UpdateProject from "./UpdateProject/UpdateProject";
import Loading_animation_view from "../../loading_animation_view/loading_animation_view";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Tooltip,
} from "@mui/material";
import { Divider } from "@mui/material";
import {
  show_projects,
  archive_project,
} from "../../../services/project_service";
import "./list_projects.css";
import { get_directions } from "../../../services/for_allServices";


function get_direction_title(id, directions) {
  // //  console.log("suppli")
  let dir_title = null;
  for (let dir of directions) {
    if (dir.id == id) { dir_title = dir.title; break; }
  }
  return dir_title;
}

function state(archived) {
  return (
    <>
      {
        archived === 1
          ? <Button variant="contained" className="status_deny">{"archivée"}</Button>
          : <Button variant="contained" className="status_success">{"non archivée"}</Button>
      }
    </>
  );
}


function List_projects() {
  const [waiting, setWaiting] = useState(false);
    let history = useHistory();

  const [directions, setDirections] = useState([]);
  const [projects, setProjects] = useState(null);
  const [allProjects, setAllProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openAddProject, setOpenAddProject] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  const [selectedProjectForUpdate, setSelectedProjectForUpdate] = useState(null);

  const [filter_direction, setfilter_direction] = useState("all");


  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage, setdataPerPage] = useState(10);
  const [data_count, setdata_count] = useState(0);


  useEffect(() => {
    async function load_data() {
      await get_directions().then((response) => {
        setDirections(response.data);
      }).catch((error) => {
       //  console.log(error.response);
      });
      await show_projects().then( (response) => {
        let tmp_data = response.data;
        if(tmp_data){
          setAllProjects(tmp_data);
          setdata_count(tmp_data.length);
          set_projects_list(tmp_data,currentPage);
        }
        
      }).catch((error) => {
        console.error("Erreur lors du chargement des projets :", error);
      });
    }
    load_data();
  }, []);


  const normalize = (text) => {
    return text
      .toString()
      .normalize("NFD") // décompose les lettres accentuées : ex. "é" devient "e" + "´"
      .replace(/[\u0300-\u036f]/g, "") // supprime les caractères d'accent : "e" + "´" devient juste "e"
      .toLowerCase(); // met tout en minuscules pour ignorer la casse
  };

  const handleSearch = (searchText) => {
    const keyword = normalize(searchText.trim());
    const page = 1;
    setCurrentPage(page);
    if (!keyword) {
      set_projects_list(allProjects,page);
      setdata_count(allProjects.length);
    } else {
      const filtered = allProjects.filter((project) =>
        Object.values(project).some(
          (value) => value && normalize(value).includes(keyword)
        )
      );
      set_projects_list(filtered,page);
      setdata_count(filtered.length);
    }
  };

  const archive_project_func = async (id, projectCode, archived) => {
    swal({
      title: "Êtes-vous sûr ?",
      text: "Ce projet sera archivé.",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then(async (willDelete) => {
        if (willDelete) {
          try {
            setWaiting(true);
            const response = await archive_project(projectCode, archived);
            setWaiting(false);
            if (response.data.success) {
              let tmp_project = [...projects];
              tmp_project[id].archived = archived;
              setProjects(tmp_project);
            } else {
              swal(
                "Erreur",
                "Une erreur est survenue lors de l'archivage.",
                "error"
              );
            }
          } catch (error) {
            swal(
              "Erreur",
              "Une erreur s'est produite lors de l'archivage.",
              "error"
            );
            setWaiting(false);
            console.error(error);
          }
        }
      });
  };

  const update_project_list = async (project_infos, update = null) => {
    let tmp_projects = [...projects];
    let tmp_all_projects = [...allProjects];
   //  console.log(update);
    if (update != null) {
      tmp_projects[update] = project_infos;
    } else {
      tmp_projects.unshift(project_infos);
      tmp_all_projects.unshift(project_infos);
    }
    setAllProjects(tmp_all_projects);
    set_projects_list(tmp_all_projects,currentPage);
  }



  async function change_page(page) {
    setCurrentPage(page); // Mise à jour de la page
    let path = history.location.pathname;
    let params = history.location.search;
    let search_params = params.split('&');
    let tmp_params = path;

    if (!params) {
      history.push(path + "?page=" + page);
    } else {
      for (let i in search_params) {
        if (search_params[i].includes("page=")) {
          search_params[i] = "page=" + page;
        }
      }
      tmp_params = path + "?" + search_params.join('&');
      if (!tmp_params.includes("page=")) {
        tmp_params += "&page=" + page;
      }
      history.push(tmp_params);
    }

    await set_projects_list(allProjects,page);
  }

  async function set_projects_list(all_projects,page) {
    const startIndex = (page - 1) * dataPerPage;
    const endIndex = startIndex + dataPerPage;

    const paginatedData = all_projects.slice(startIndex, endIndex);
   //  console.log(all_projects,startIndex, endIndex);
    setProjects(paginatedData);
  }

  function set__direction(value) {
    let path = history.location.pathname;
    let page = 1;
    history.push(path + "?direction=" + value);
    setCurrentPage(page);
    if (value=="all") {
      set_projects_list(allProjects, page);
      setdata_count(allProjects.length);
    } else {
      const filtered = allProjects.filter((project) =>
        project.direction == value
      );
      set_projects_list(filtered, page);
      setdata_count(filtered.length);
    }
    setfilter_direction(value);
  }



  return (
    <div className="projects-container">
      <div className="three_forms_header_container">
        <div className="title_container" style={{ display: "flex", alignItems: "end" }}>
          <div style={{ marginRight: "5px" }}>
            <Tooltip title="Ajouter un projet" arrow>
              <Fab onClick={() => setOpenAddProject(true)}>
                <AddIcon />
              </Fab>
            </Tooltip>
          </div>
          <div>Liste des projets</div>
        </div>
        <div className="search_filter_container">
           <FormControl variant="standard" className="header_form" >
            <InputLabel id="demo-simple-select-helper-label">Direction</InputLabel>
            <Select required value={filter_direction}
              onChange={e => { set__direction(e.target.value) }} >

              <MenuItem value={"all"}>Tous</MenuItem>
              {
                directions.map((direction, id) => (
                  <MenuItem value={direction.id} key={"direction_" + id} >{direction.title}</MenuItem>
                ))
              }

            </Select>
          </FormControl>
          <SearchProject onSearch={handleSearch} />
        </div>
      </div>
      {
        projects != null
          ?<><TableContainer component={Paper}>
            <Table className="projects_table">
              <TableHead>
                <TableRow>
                  <TableCell align="left">Code de projet</TableCell>
                  <TableCell align="left" style={{ width: "220px" }}>
                    Titre
                  </TableCell>
                  <TableCell align="left">Direction</TableCell>
                  <TableCell align="left">Chef du projet</TableCell>
                  <TableCell align="left">date de début</TableCell>
                  <TableCell align="left">date de fin</TableCell>
                  <TableCell align="left">Budget estimatif</TableCell>
                  {/*<TableCell align="right">Budget engagé</TableCell>
              <TableCell align="right">Budget réalisé</TableCell>*/}
                  <TableCell align="left" style={{ width: "30px" }}>
                    Détails
                  </TableCell>
                  <TableCell align="left">Actions</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {projects.map((project, index) => (
                  <TableRow key={index}>
                    <TableCell align="left">
                      <div style={{ width: 'fit-content' }}>
                        {project.project_code}
                        <div style={{ width: '100%', display: 'flex' }}>
                          <Tooltip title="Modifier le projet">
                            <EditIcon
                              className="my_icon"
                              style={{
                                cursor: "pointer",
                                marginRight: "10px",
                                color: "#1976d2",
                              }}
                              onClick={() => {
                                setSelectedProjectForUpdate({ ...project, index: index });
                              }}
                            />
                          </Tooltip>
                        </div>
                      </div>
                    </TableCell>
                    <TableCell align="left">{project.title}</TableCell>
                    <TableCell align="left">{get_direction_title(project.direction, directions) ?? "Aucune"}</TableCell>
                    <TableCell align="left">{project.project_manager}</TableCell>
                    <TableCell align="left">{(new Date(project.start_date)).toLocaleDateString()}</TableCell>
                    <TableCell align="left">{(new Date(project.end_date)).toLocaleDateString()}</TableCell>
                    <TableCell align="left">
                      {project.estimated_budget} MAD
                    </TableCell>
                    {/*<TableCell align="right">
                  {project.committed_budget} MAD
                </TableCell>
                <TableCell align="right">
                  {project.realized_budget} MAD
                </TableCell>*/}
                    <TableCell align="left">
                      <VisibilityIcon
                        className="my_icon editIcon"
                        onClick={() => setSelectedProject(project)}
                        style={{ cursor: "pointer" }}
                      />
                    </TableCell>
                    <TableCell align="left">
                      <div className='documentsStatus_valide'  >
                        <div>
                          <div><CheckIcon className="checkIcon" onClick={() => archive_project_func(index, project.project_code, 0)} /></div>
                          <div><CloseSharpIcon className="closeSharpIcon" onClick={() => archive_project_func(index, project.project_code, 1)} /></div>
                        </div>
                        {state(project.archived)}
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          {
            projects.length !== 0
              ? <div className="pagination_container">
                <Pagination
                  activePage={Number(currentPage)}
                  itemsCountPerPage={dataPerPage}
                  totalItemsCount={Number(data_count)}
                  pageRangeDisplayed={4}
                  onChange={change_page.bind(this)}
                />
              </div>
              : <></>
          }
          </>
      : <Loading_animation_view />
      }

      {openAddProject && (
        <AddProjectForm onClose={() => setOpenAddProject(false)} update_project_list={update_project_list} directions={directions} />
      )}

      {selectedProject && (
        <Details_projects
          project={selectedProject}
          directions={directions}
          onClose={() => setSelectedProject(null)}
        />
      )}

      {selectedProjectForUpdate && (
        <UpdateProject
          project={selectedProjectForUpdate}
          onClose={() => setSelectedProjectForUpdate(null)}
          update_project_list={update_project_list}
          directions={directions}
        />
      )}
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={waiting}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}
export default List_projects;
